import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="button-spinner"
export default class extends Controller {
  static classes = ['spinner'];

  connect() {
    // Bind event handlers once so we can remove them on disconnect
    this.removeSpinnerBound = this.removeSpinner.bind(this);

    // Listen for Turbo events that signal that new content is about to render
    document.addEventListener('turbo:before-render', this.removeSpinnerBound);
    document.addEventListener(
      'turbo:before-stream-render',
      this.removeSpinnerBound
    );
    // You may also add turbo:frame-load or turbo:load if you use those in your app
    document.addEventListener('turbo:load', this.removeSpinnerBound);
  }

  disconnect() {
    document.removeEventListener(
      'turbo:before-render',
      this.removeSpinnerBound
    );
    document.removeEventListener(
      'turbo:before-stream-render',
      this.removeSpinnerBound
    );
    document.removeEventListener('turbo:load', this.removeSpinnerBound);
  }

  showSpinner(event) {
    // Do not preventDefault so Turbo can process the click
    // If a spinner isn't already present, append one
    if (!this.spinnerPresent()) {
      // Add visual indication without disabling the button
      // This allows form submission to proceed normally
      this.element.classList.add('opacity-50', 'pointer-events-none');

      // Store original text content if we need to restore it later
      this.element.dataset.originalContent = this.element.innerHTML;

      const spinner = document.createElement('span');
      // DaisyUI spinner classes – adjust as needed
      spinner.className = 'loading loading-spinner ml-2';
      if (this.hasSpinnerClass) {
        spinner.classList.add(this.spinnerClass);
      }
      // Mark this element so we can find/remove it later
      spinner.setAttribute('data-spinner', 'true');
      if (this.element.children.length > 0) {
        // append to last child
        this.element.children[this.element.children.length - 1].appendChild(
          spinner
        );
      } else {
        this.element.appendChild(spinner);
      }
    }
  }

  removeSpinner() {
    // Look for our spinner element (if any) and remove it
    const spinner = this.element.querySelector('[data-spinner="true"]');
    if (spinner) {
      spinner.remove();
      // Enable the button and restore original state
      this.element.classList.remove('opacity-50', 'pointer-events-none');

      // Restore original content if needed
      if (this.element.dataset.originalContent) {
        this.element.innerHTML = this.element.dataset.originalContent;
        delete this.element.dataset.originalContent;
      }
    }
  }

  spinnerPresent() {
    return this.element.querySelector('[data-spinner="true"]') !== null;
  }
}
